// What's not here:
// - reopen ws connection on server down. mitigation: ask user to refresh browser

export class WS {
  public endpoint: string;
  public handlers: any[] = [];
  public isAlive: boolean = false;
  public ws: any = null;
  private pingInterval: any;
  private failedPingCounter: number = 0;

  constructor(wsEndpoint: string) {
    this.endpoint = wsEndpoint;
    this.open(this.endpoint);
  }
  public onCloseHandler: () => void = () => {
    // no-op
  }
  public onAliveHandler: () => void = () => {
    // no-op
  }

  public open(endpoint: string) {
    this.ws = new WebSocket(endpoint);
    this.ws.addEventListener('open', () => {
      this.isAlive = true;
      if (typeof this.onAliveHandler === 'function') {
        this.onAliveHandler();
      }
    });

    this.ws.addEventListener('message', (messageEvent: any) => {
      this.isAlive = true;
      if (messageEvent.data !== 'PONG') {
        this.handlers.forEach((handler: any) => {
          handler.handleMessage(this.ws, messageEvent);
        });
      }
    });

    // ensure that the server is there
    this.failedPingCounter = 0;
    this.pingInterval = setInterval(() => {
      try {
        if (this.isAlive === false) {
          this.failedPingCounter++;
          if (this.failedPingCounter > 3) {
            console.log('failed to PING ws server: websocket disconnected');
            clearInterval(this.pingInterval);
            if (typeof this.onCloseHandler === 'function') {
              this.onCloseHandler();
            }
          }
        } else {
          this.isAlive = false;
          this.failedPingCounter = 0;
          this.ws.send('PING');
        }
      } catch (e) {
        console.error('failed to PING ws server:', e.message);
      }
    }, 5000);
  }

  public destroy() {
    clearInterval(this.pingInterval);
  }

  public reopen() {
    this.open(this.endpoint);
    this.init();
  }

  public async init() {
    for (let i = 0; i < 3; i++) {
      if (!this.isAlive) {
        try {
          await this._sleep(200);
        } catch (e) {
          // no-op
        }
      }
    }

    if (!this.isAlive) {
      throw new Error('websocket endpoint timeout');
    }
  }

  public addHandler(handlerFn: any) {
    this.handlers.push(handlerFn);
  }

  public send(data: any) {
    if (!this.isAlive) {
      return 'websocket is not in ready state';
    }
    this.ws.send(data);
    return null;
  }

  public sendJSON(jsonObj: object) {
    return this.send(JSON.stringify(jsonObj));
  }

  private _sleep(ms: number) {
    return new Promise((resolve: any) => setTimeout(resolve, ms));
  }
}
